import { promisify } from '../utils/Util'

class FormUtil {
  async validateForm(form) {
    let formErrors = null
    let values = null
    try {
      const validateAsync = promisify(form.validateFieldsAndScroll)
      values = await validateAsync()
    } catch (err) {
      formErrors = err
      console.log('validation error is' + err)
    }
    return { errors: formErrors, values: values }
  }
}

export default new FormUtil()



// WEBPACK FOOTER //
// ./src/utils/FormUtil.js